import type { TFunction } from 'i18next';

export type ElapsedUnit = 'now' | 'minutes' | 'hours' | 'days';

export type Elapsed = { unit: ElapsedUnit; value: number };

const MINUTE_MS = 60000;
const HOUR_MS = 3600000;
const DAY_MS = 86400000;

export const getElapsed = (now: number, timestamp: number): Elapsed => {
  const diff = Math.max(0, now - timestamp);

  if (diff < MINUTE_MS) return { unit: 'now', value: 0 };
  if (diff < HOUR_MS) return { unit: 'minutes', value: Math.floor(diff / MINUTE_MS) };
  if (diff < DAY_MS) return { unit: 'hours', value: Math.floor(diff / HOUR_MS) };
  return { unit: 'days', value: Math.floor(diff / DAY_MS) };
};

export const formatElapsed = (t: TFunction, elapsed: Elapsed): string => {
  if (elapsed.unit === 'now') return t('notifications:just-now');
  return `${elapsed.value} ${t(`notifications:${elapsed.unit}`)}`;
};
